import { render } from "./SBPQRPaymentDetails.vue?vue&type=template&id=dbc240f0&scoped=true&ts=true"
import script from "./SBPQRPaymentDetails.vue?vue&type=script&lang=ts"
export * from "./SBPQRPaymentDetails.vue?vue&type=script&lang=ts"

import "./SBPQRPaymentDetails.vue?vue&type=style&index=0&id=dbc240f0&scoped=true&lang=css"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc240f0"]])

export default __exports__